module.exports = __webpack_public_path__ + "static/media/addMember.539cd304.svg";